import React, { useState } from "react";
import useFetch from "../../api/fetch";
import {PLATFORM_NAMES} from '../../enums/platforms';

import './translation-keys-export.styles.scss';

export default function TranslationKeysExport() {
    const fetch = useFetch();

    const [exportPlatforms, setExportPlatforms] = useState([]);

    const onSubmit = async () => {

        var formData = new FormData();
        formData.append('platforms', exportPlatforms.join(','));
        const result = await fetch("/api/key/export", {
            method: "POST",
            body: formData
        })
        .then(res => res.blob())
        .then(res => {
            window.$('#export-translations').modal("hide");
            const url = new Blob([res],{type:'application/zip'});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(url);
            link.setAttribute('download', 'translations.zip');
            document.body.appendChild(link);
            link.click();
        });
    }

    const onChange = (e) => {
        const option = e.target;
        let checkedOpt = exportPlatforms;

        if(option.checked) {
            checkedOpt.push(option.value);
        } else {
            const index = checkedOpt.indexOf(option.value);
            if(index > -1)
                checkedOpt.splice(index, 1);
        }

        setExportPlatforms(checkedOpt);
    }

    return (
        <div className="modal fade" id="export-translations" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Choose the platforms you want to export</h3>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12 mt-3">
                                {Object.keys(PLATFORM_NAMES).map((p, index) => (
                                    p.length > 0 && <div className="custom-control custom-checkbox" key={index}>
                                        <input type="checkbox" className="custom-control-input" id={p} value={p} onChange={onChange}/>
                                        <label className="custom-control-label cursor-pointer" htmlFor={p}>{PLATFORM_NAMES[p]}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-mondly btn-blue" onClick={() => { onSubmit() }}>Export</button>
                    </div>
                </div>
            </div>
        </div>

    )
}